import React from "react";

function Footer() {
  const emailAddress = "sriharshachalasani@jssuni.edu.in";

  const handleEmailClick = () => {
    window.location.href = `mailto:${emailAddress}`;
  };
  return (
    <footer>
      <p className="center footer-up">
        A collaboration of JSS AHER ( Dept. of Clinical Pharmacy & Geriatrics )
        - JSS ATE Noida ( Dept. of IT )
      </p>
      <p className="center">
        Developed by Dr Jehath Syed, Mr. Vansh Chopra, Ms. Auroshree Verma, Dr.
        Vineeta Khemchandani, Dr. Prathiba Pereira, Dr. Vikram Patil, Dr. M
        Ramesh, Dr. Sri Harsha Chalasani*
      </p>
      <p className="center footer-down">
        Email: &nbsp;
        <a href={`mailto:${emailAddress}`} onClick={handleEmailClick}>
          sriharshachalasani@jssuni.edu.in
        </a>
      </p>
    </footer>
  );
}

export default Footer;
